import { Component } from '@angular/core';
import { IonicPage, NavController } from 'ionic-angular';
import { UserModel } from '../../providers/user/user.model';
import { UserProvider } from '../../providers/user/user.provider';

/**
 * Generated class for the UserPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-user',
  templateUrl: 'user.html',
})
export class UserPage {

  user: UserModel = new UserModel();

  constructor(
    public navCtrl: NavController,
    public userProvider: UserProvider
  ) {}

}



// WEBPACK FOOTER //
// ./src/pages/user/user.ts